import { useEffect, useState } from 'react';
import { t } from '../i18n.js';

/**
 * Hoe vers een pagina is die zichzelf ververst, zoals *Live* op de kaart: een lampje met de tijd van de
 * laatste stand, en in rood (met tekst, niet alleen kleur) als bijwerken niet meer lukt. Een eigen klok:
 * de hele pagina elke seconde opnieuw tekenen alleen hiervoor, is te veel.
 *
 * `q` is de vraag van TanStack Query, `elke` hoe vaak die ververst (ms). In een tabblad op de achtergrond
 * vraagt de pagina niets (dat doet TanStack Query zo), en dan is achterlopen geen storing: bij
 * terugkomen haalt hij meteen een nieuwe stand.
 */
const tijd = (ms) => new Date(ms).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

export default function Bijgewerkt({ q, elke }) {
  const [nu, zetNu] = useState(Date.now());
  useEffect(() => { const k = setInterval(() => zetNu(Date.now()), 1000); return () => clearInterval(k); }, []);
  const laatst = q.dataUpdatedAt;
  const zichtbaar = typeof document === 'undefined' || document.visibilityState === 'visible';
  const weg = q.isRefetchError || (zichtbaar && laatst && nu - laatst > elke * 3 + 10_000);
  return (
    <span className={`live ${weg ? 'weg' : ''}`} role="status">
      <i aria-hidden="true" />
      {weg ? t('Bijwerken lukt niet sinds {tijd}', { tijd: tijd(laatst) }) : t('Bijgewerkt · {tijd}', { tijd: tijd(laatst) })}
    </span>
  );
}
